import { Component, OnInit } from '@angular/core';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'app-privacy-policy-management',
  templateUrl: './privacy-policy-management.component.html',
  styleUrls: ['./privacy-policy-management.component.scss']
})
export class PrivacyPolicyManagementComponent implements OnInit {
  faArrowRight = faArrowRight;

  constructor() { }

  ngOnInit(): void {}

}
